export enum EBulkOperationStatus {
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface TBulkOperation {
  _id: string;
  status: EBulkOperationStatus;
  errorMessage?: string;
  createdDate: string;
  completedDate?: string;
}
